import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CartItemType } from '../../../actions/shop';

export function useHasCampJourInCart() {
  const cart = useSelector(state => state.shop?.cart ?? []);
  return useMemo(
    () => Array.isArray(cart) && cart.some(item => item?.type === CartItemType.CampJour),
    [cart]
  );
}